<nav
  min-content-width
  class="site-nav flex align-items--center justify--center"
>
  <div
    class="flex align-items--center color--light position--absolute"
    style="left: 0"
  >
    <a
      *ngIf="!hideMenuButton"
      class="site-nav__btn site-nav__btn--menu"
      (taInteract)="toggleNav('menu')"
    ></a>
    <div
      [@fadeInOut]
      [@verticalShrink]
      *ngIf="(backLocation$ | async)"
      class="border--thin--right"
    ></div>
    <ta-link
      [@fadeInOut]
      [@horizontalSlideInOut]
      *ngIf="(backLocation$ | async) as backLocation"
      [taRouterLink]="backLocation"
    >
      <div
        style="width: 60px"
        class="ph--2 flex__item--align-self-stretch flex justify--center align-items--center site-nav__btn"
      >
        <span style="color: #ffffff; font-size: 5rem">
          <ta-icon icon="left"></ta-icon>
        </span>
      </div>
    </ta-link>
  </div>

  <a
    *ngIf="logoLinksToTapadHomepage; else tapadLogo"
    href="https://tapad.com"
    style="line-height: 0"
  >
    <ng-container *ngTemplateOutlet="tapadLogo"></ng-container>
  </a>

  <ng-template #tapadLogo>
    <img class="site-nav__logo" src="/lantern/assets/images/TTG_Lockup.svg" />
  </ng-template>

  <div class="site-nav__logo-text">{{ logoText }}</div>
</nav>

<div
  class="flyout-scrim"
  [class.flyout-scrim--visible]="visible"
  (taInteract)="hideNav()"
></div>

<div class="flyout" [class.flyout--visible]="visible" [ngSwitch]="nav">
  <!--Primary Navigation-->
  <div *ngSwitchCase="'menu'" class="flyout__item">
    <h1 class="flyout__header">{{ displayName }}</h1>

    <div class="flyout__content flyout__content--no-padding">
      <ng-content select="[app-nav]"></ng-content>
    </div>

    <div class="flyout__footer">
      <a
        [href]="this.appConfig.docsUrl"
        target="_blank"
        class="nav__item nav__item--small"
        >Tapad Help</a
      >
      <a
        *ngIf="(auth.isLoggedIn | async); else loginLink"
        (taInteract)="logout()"
        class="nav__item nav__item--small nav__item--logout"
        >Logout</a
      >

      <ng-template #loginLink>
        <a
          routerLink="/go-login"
          class="nav__item nav__item--small nav__item--logout"
          >Login</a
        >
      </ng-template>
    </div>
  </div>

  <!--Favorites-->
  <div *ngSwitchCase="'favorites'" class="flyout__item">
    <div class="flyout__header">Favorites</div>

    <div class="flyout__content flyout__content--no-padding">
      <ng-content select="[favorites]"></ng-content>
    </div>
  </div>
</div>
